module.exports = __webpack_public_path__ + "img/mono_9.8a9dfca5.png";